// These are kept in one separate file for developer friendliness,
// doing this makes it easy to see all that's going on in one application
// and avoid duplication when collaborating

// Prelim Form actions
export const UPDATE_STATIC_DATA = 'UPDATE_STATIC_DATA';
export const UPDATE_LABELS = 'UPDATE_LABELS';
export const UPDATE_PRELIM_FORM = 'UPDATE_PRELIM_FORM';
export const PRELIM_FORM_SUBMITTED = 'PRELIM_FORM_SUBMITTED';

// Applicant+Admin actions
export const UPDATE_USER = 'UPDATE_USER';
export const LOG_OUT = 'LOG_OUT';
export const UPDATE_IMPERSONATE_USER = 'UPDATE_IMPERSONATE_USER';

// Applicant actions
export const UPDATE_APPLICANT = 'UPDATE_APPLICANT';
export const DELETE_FROM_APPLICANT_LIST = 'DELETE_FROM_APPLICANT_LIST';
export const UPDATE_TEMP_STATE = 'UPDATE_TEMP_STATE';
export const UPDATE_TECHNOLOGY_SURVEY = 'UPDATE_TECHNOLOGY_SURVEY';

// Admin actions
export const UPDATE_APPLICANT_LICENSES = 'UPDATE_APPLICANT_LICENSES';
export const UPDATE_APPLICANTS_LIST = 'UPDATE_APPLICANTS_LIST';
export const UPDATE_EVENT_LIST = 'UPDATE_EVENT_LIST';
export const UPDATE_APPLICANTS_PAGE = 'UPDATE_APPLICANTS_PAGE';
export const UPDATE_APPLICANT_ADMIN = 'UPDATE_APPLICANT_ADMIN';
export const UPDATE_CURRENT_APPLICANT_ADMIN = 'UPDATE_CURRENT_APPLICANT_ADMIN';
export const ADD_APPLICANT_ADMIN = 'ADD_APPLICANT_ADMIN';
export const DELETE_APPLICANT_ADMIN = 'DELETE_APPLICANT_ADMIN';
export const CHANGE_NAV_COLUMN_STATE = 'CHANGE_NAV_COLUMN_STATE';
export const UPDATE_APPLICANT_BEHAVIORAL_ANS = 'UPDATE_APPLICANT_BEHAVIORAL_ANS';
export const UPDATE_APPLICANT_WORK_OBJECTIVES = 'UPDATE_APPLICANT_WORK_OBJECTIVES';
export const UPDATE_APPLICANT_INTERVIEW_RATINGS = 'UPDATE_APPLICANT_INTERVIEW_RATINGS';
export const UPDATE_APPLICANT_ASSESSMENTS = 'UPDATE_APPLICANT_ASSESSMENTS';
export const UPDATE_APPLICANT_REFERENCES_INTERVIEWS = 'UPDATE_APPLICANT_REFERENCES_INTERVIEWS';
export const UPDATE_PLACEMENT_SPECIALISTS = 'UPDATE_PLACEMENT_SPECIALISTS';
export const UPDATE_PINNED_APPLICANTS = 'UPDATE_PINNED_APPLICANTS';
export const CLEAR_APPLICANT = 'CLEAR_APPLICANT';
export const FETCH_PINNED_APPLICANTS = 'FETCH_PINNED_APPLICANTS';
export const UPDATE_ALERTS = 'UPDATE_ALERTS';
export const LOAD_PINS = 'LOAD_PINS';
export const UPDATE_PINS = 'UPDATE_PINS';
export const UPDATE_CONTACTS_TABLE_SEARCH_TERMS = 'UPDATE_CONTACTS_TABLE_SEARCH_TERMS';
export const UPDATE_CONTACTS_TABLE_FILTERS = 'UPDATE_CONTACTS_TABLE_FILTERS';
export const UPDATE_COMPANIES_TABLE_SEARCH_TERMS = 'UPDATE_COMPANIES_TABLE_SEARCH_TERMS';
export const UPDATE_COMPANIES_TABLE_FILTERS = 'UPDATE_COMPANIES_TABLE_FILTERS';
export const UPDATE_JOB_REQUESTS_FILTERS = 'UPDATE_JOB_REQUESTS_FILTERS';
export const UPDATE_JOB_REQUESTS_TERMS = 'UPDATE_JOB_REQUESTS_TERMS';

// Contact actions
export const UPDATE_CONTACT = 'UPDATE_CONTACT';
export const UPDATE_CONTACT_IN_CONTACT_WORKSHEET = 'UPDATE_CONTACT_IN_CONTACT_WORKSHEET';
export const CLEAR_CONTACT_IN_CONTACT_WORKSHEET = 'CLEAR_CONTACT_IN_CONTACT_WORKSHEET';

export const UPDATE_CONTACTS_LIST = 'UPDATE_CONTACTS_LIST';
export const UPDATE_CONTACTS_PAGE = 'UPDATE_CONTACTS_PAGE';
export const UPDATE_CONTACT_EVENT_LIST = 'UPDATE_CONTACT_EVENT_LIST';

// pagination
export const GO_TO_CONTACTS_PAGE = 'GO_TO_CONTACTS_PAGE';

// Company actions
export const UPDATE_COMPANY = 'UPDATE_COMPANY';
export const UPDATE_COMPANIES_LIST = 'UPDATE_COMPANIES_LIST';
export const UPDATE_COMPANIES_PAGE = 'UPDATE_COMPANIES_PAGE';
export const UPDATE_COMPANY_CONTACTS = 'UPDATE_COMPANY_CONTACTS';
export const UPDATE_COMPANY_JOBS = 'UPDATE_COMPANY_JOBS';
export const FILTER_COMPANY_JOBS = 'FILTER_COMPANY_JOBS';


// Browser Data actions
export const GET_SCROLLBAR_WIDTH = 'GET_SCROLLBAR_WIDTH';
export const SET_USERAGENT = 'SET_USERAGENT';

// Company actions
export const GET_COMPANY_INFO = 'GET_COMPANY_INFO';

// Client actions
export const UPDATE_CONTACT_PROFILE = 'UPDATE_CONTACT_PROFILE';
export const UPDATE_PROFILE = 'UPDATE_PROFILE';

export const CREATE_JOB_REQUEST = 'CREATE_JOB_REQUEST';
export const UPDATE_JOB_REQUEST = 'UPDATE_JOB_REQUEST';
export const RESET_JOB_REQUEST = 'RESET_JOB_REQUEST';

export const CREATE_JOB_REQUEST_DOCUMENTS = 'CREATE_JOB_REQUEST_DOCUMENTS';
export const UPDATE_JOB_REQUEST_DOCUMENTS = 'UPDATE_JOB_REQUEST_DOCUMENTS';
export const RESET_JOB_REQUEST_DOCUMENTS = 'RESET_JOB_REQUEST_DOCUMENTS';

export const UPDATE_JOB_REQUESTS = 'UPDATE_JOB_REQUESTS';
export const UPDATE_COMPANY_JOB_REQUESTS = 'UPDATE_COMPANY_JOB_REQUESTS';
export const UPDATE_CLIENT_JOB_REQUESTS = 'UPDATE_CLIENT_JOB_REQUESTS';

// Worksheets
export const UPDATE_WORKSHEET = 'UPDATE_WORKSHEET';
export const REMOVE_WORKSHEET = 'REMOVE_WORKSHEET';


// UI actions
export const SET_NAV_STATE = 'SET_NAV_STATE';
export const HIDE_SNACKBAR = 'HIDE_SNACKBAR';
export const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const SHOW_SPINNER = 'SHOW_SPINNER';
export const HIDE_SPINNER = 'HIDE_SPINNER';
export const SHOW_CONTROLS = 'SHOW_CONTROLS';
export const HIDE_CONTROLS = 'HIDE_CONTROLS';
export const WARNING_TOAST = 'WARNING_TOAST';

// Employee

export const CREATE_EMPLOYEE = 'CREATE_EMPLOYEE';
export const REMOVE_EMPLOYEE = 'REMOVE_EMPLOYEE';
export const UPDATE_EMPLOYEE = 'UPDATE_EMPLOYEE';
export const STORE_EMPLOYEES = 'STORE_EMPLOYEES';



// WEBPACK FOOTER //
// ./shared/redux/actionTypes/index.js